import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/providers/auth-provider";
import WsStatusDot from "@/components/shell/ws-status-dot";
import NotificationButton from "@/components/shell/notification-button";
import PillButton from "@/components/common/pill-button";

/** Top app bar: logo + WS status dot + action stubs + logout. */
export default function TopBar() {
  const { logout } = useAuth();

  // At scroll=0 keep the bar fully opaque (matches the original look); once
  // content scrolls underneath, drop the fill to ~70% + backdrop-blur so the
  // page peeks through like an iOS nav bar.
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={[
        "sticky top-0 z-40 flex items-center justify-between px-4 py-2 border-b border-border transition-colors",
        scrolled ? "bg-surface/70 backdrop-blur-md" : "bg-surface",
      ].join(" ")}
      // Extend the surface colour under iOS' notch/status bar in standalone
      // PWA mode so there's no black gap between the system chrome and the
      // brand row. viewport-fit=cover must be set on the meta for this.
      style={{ paddingTop: "calc(0.5rem + env(safe-area-inset-top))" }}
    >
      {/* Brand */}
      <Link to="/" className="flex items-center gap-2">
        <img src="/kuant-logo.svg" alt="kuant" className="h-6 w-auto" />
      </Link>

      {/* Actions */}
      <div className="flex items-center gap-2">
        <NotificationButton />

        <WsStatusDot />

        <PillButton
          variant="danger"
          onClick={() => { void logout(); }}
          aria-label="Log out"
        >
          Logout
        </PillButton>
      </div>
    </header>
  );
}
